import { MutationTree } from "vuex";
import { IChurningState } from "@/modules/Churning/vuex/state";
import { ChurningRecord } from "@/modules/Churning/interfaces/churningResponse.interface";
const mutations: MutationTree<IChurningState> = {
  setChurningLoading(state, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  setChurningError(state, error: string | null) {
    state.error = error;
  },
  setChurningData(state, payload: ChurningRecord[]) {
    state.churningData = payload;
    state.error = null;
    state.isLoading = false;
  },
  resetChurningState(state) {
    state.churningData = null;
    state.error = null;
    state.isLoading = false;
  },
};

export default mutations;
